import URLConfig from '@Config/urls/url.config';
import { LinkItemProps } from '@Layouts/sidebar/AppSidebar';

const URL = URLConfig.FRAUD_MANAGEMENT.EMITTER_MENU;

const EmitterMenuLink: Array<LinkItemProps> = [
  {
    name: 'Liste Règles Transgressées',
    link: URL.LIST_OF_BROKEN_RULES,
    level: 2,
  },
  {
    name: 'Liste Cartes Suspectes',
    link: URL.LIST_OF_SUSPECT_CARDS,
    level: 2,
  },
  {
    name: 'Liste Transactions Suspectes',
    link: URL.LIST_OF_SUSPECT_TRANSACTIONS,
    level: 2,
  },
  {
    name: 'Valeur Référentielle Porteur',
    link: URL.HOLDER_REFERENTIAL_VALUE,
    level: 2,
  },
];

export default EmitterMenuLink;
